export default __webpack_public_path__ + "static/media/BumpFund_Icons_04.55efb9fa.svg";